// extracted by mini-css-extract-plugin
module.exports = {"statusLine":"CampaignDetail_statusLine__tHHra"};